import { ScrollArea } from "./ScrollArea";

const FixedScrollArea = ({ className, children }) => {
  return (
    <ScrollArea className={className} type="always">
      {children}
    </ScrollArea>
  );
};

export default FixedScrollArea;